/**
 * Pièces jointes du dossier patient.
 *
 * Ensembles fermés partagés entre la base (pgEnum), le serveur (zod) et le front (libellés i18n).
 * Règle : valeurs ASCII en snake_case, jamais de libellé humain ici. Ce fichier est réexporté par
 * `../enums.js`, qui reste le seul point d'entrée : personne n'importe un domaine directement.
 */

/**
 * Origine d'un document. `upload` : un fichier déposé par le cabinet. `generated` : une pièce
 * produite par l'application (facture, courrier) rangée dans le même dossier.
 */
export const documentKinds = ['upload', 'generated'] as const;
export type DocumentKind = (typeof documentKinds)[number];

/**
 * Classement d'un document dans le dossier patient. La V1 n'en avait aucun : tout arrivait en vrac
 * dans un onglet unique. Liste fermée et ASCII, les libellés sont dans les traductions.
 */
export const documentCategories = [
  'prescription',
  'report',
  'imaging',
  'letter',
  'invoice',
  'other',
] as const;
export type DocumentCategory = (typeof documentCategories)[number];

/**
 * Catégories qu'un membre choisit au dépôt ou à la modification. « Facture » n'y est pas : elle est
 * réservée aux pièces comptables que l'application imprime et range elle-même, qui se consultent
 * dans l'onglet Factures et non dans l'onglet Documents.
 */
export const documentUploadCategories = [
  'prescription',
  'report',
  'imaging',
  'letter',
  'other',
] as const satisfies readonly DocumentCategory[];
export type DocumentUploadCategory = (typeof documentUploadCategories)[number];
